module.exports = __webpack_public_path__ + "static/img/webpc2.d14fb9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/webpc2.png
// module id = ODp7
// module chunks = 1